define(function(require) {
    const BulkActionBarTemplate = require('./BulkActionBar.template.html');
    const BaseView = require('app/Base.view');
    const $ = require('jquery');
    const _ = require('underscore');
    const Backbone = require('backbone');
    const CC = require('CC');
    require('./BulkActionBar.css');

    const BulkActionBarView = BaseView.extend({
        defaults: {
            // A list of selected models
            selectedList: undefined,
            // A postfix for the the selection counter label (eg. /<maximum allowed>)
            selectionPostfix: '',
            // A list of actions (id, name, ccEventName)
            bulkActions: [],
            showClearButton: false, // whether to show the 'Clear All' button
            maximumVisible: Infinity,
            showBulkActionName: false
        },

        template: _.template(BulkActionBarTemplate),

        events: {
            'click .action': 'handleActionClick',
            'click .clear-selected': 'handleClearClick'
        },

        initialize: function(options) {
            const self = this;

            _.extend(
                self,
                self.defaults,
                {
                    selectedList: new Backbone.Collection()
                },
                options
            );
            self.ellipsisAction = 'show';
            self.listenTo(self.selectedList, 'add', self.render);
            self.listenTo(self.selectedList, 'remove', self.render);
            self.listenTo(self.selectedList, 'reset', self.render);
        },

        handleActionClick: function(evt) {
            const eventName = $(evt.currentTarget).attr('data-event-name');
            if (!_.isUndefined(eventName)) {
                CC.Events.trigger(eventName, this.selectedList);
            }
        },

        handleClearClick: function() {
            this.trigger('deselectAll');
        },

        render: function() {
            const self = this;

            const numberVisible = self.shouldShowAll ? self.selectedList.length : self.maximumVisible;
            const viewOptions = {
                selectedList: self.selectedList.models,
                selectionPostfix: self.selectionPostfix,
                bulkActions: _.map(self.bulkActions, bulkAction => {
                    // Strip out any html (eg. icons) from the names when used as a tile
                    bulkAction.title = $('<div>')
                        .html(bulkAction.name)
                        .text();
                    bulkAction.isDisabled =
                        _.isNumber(bulkAction.maximumAllowed) && this.selectedList.length > bulkAction.maximumAllowed;
                    return bulkAction;
                }),
                showClearButton: self.showClearButton,
                numberVisible: numberVisible,
                isDisabled: self.selectedList.length > 0 ? '' : 'disabled',
                showBulkActionName: self.showBulkActionName,
                hasHiddenItems: self.selectedList.length > self.maximumVisible,
                asOverlay: true
            };
            self.$el.html(self.template(viewOptions));

            CC.Events.trigger('BulkActionBar:StateChange', 'enabled');

            return self;
        }
    });

    return BulkActionBarView;
});
